import queryString from "query-string";
import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const insertClaim = async (dto) => {
  const { data } = await axiosConsumer.post("/ace2/claim", dto);
  return data?.details || data;
};

export const insertClaimItems = async (claimId, dto) => {
  const { data } = await axiosConsumer.post(
    `/ace2/claim/${claimId}/items`,
    dto
  );
  return data;
};

export const removeClaimItem = async (claimItemId) => {
  const { data } = await axiosConsumer.delete(
    `/ace2/claim/items/${claimItemId}`
  );
  return data;
};

export const insertClaimItemDamages = async (dto) => {
  const { data } = await axiosConsumer.post(`/ace2/claim/damages`, dto);
  return data;
};

export const submitClaim = async (claimId, oldstatus) => {
  const { data } = await axiosConsumer.post(
    `/ace2/claim/${claimId}/submit?${queryString.stringify({
      ...(oldstatus ? { oldstatus } : {}),
    })}`
  );
  return data;
};

export const updateCustomerInfo = async (customerId, body) => {
  const { data } = await axiosConsumer.put(`/ace2/contact/${customerId}`, body);
  return data;
};

export const deleteClaimDamageItem = async (
  id: number | string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.delete(`/ace2/claim/damages/${id}`);
  return data;
};

export const deleteClaim = async (id: number | string): Promise<unknown[]> => {
  const { data } = await axiosConsumer.delete(`/ace2/claim/${id}`);
  return data;
};

export const getWarrnty = async (
  warrantyId: number | string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(`/ace2/warranty/${warrantyId}`);
  return data;
};

export const getClaim = async (
  claimId: number | string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(`/ace2/claim/${claimId}`);
  return data;
};

export const claimItemSaveFileInfo = async (
  claimItemId: number | string,
  body
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.put(
    `/ace2/claim/item/${claimItemId}`,
    body
  );
  return data;
};

export const getPreSignedUrl = async (
  claimId: string,
  fileType: string
): Promise<string | null> => {
  const { data } = await axiosConsumer.get(
    `/ace2/claim/${claimId}/file-upload-url`,
    {
      params: {
        fileType,
      },
    }
  );
  return data;
};

export const removeClaimPhoto = async (dto) => {
  const { claimId, fileName } = dto;
  return axiosConsumer.delete(`/ace2/claim/${claimId}/${fileName}`);
};
